export const environmentDetailsInternalSteps = [
  {
    selector: "#environment-details-header-1",
    content:
      "This area shows the client name and environment name of the Mirth Connect Environment. If you chose to modify the name of the environment, please be aware that this will not change the setting on your remote Mirth Connect server.",
  },
  {
    selector: "#environment-details-header-2",
    content:
      "This area shows the summary of the Mirth Connect Environment.",
  },
  {
    selector: "#channel-action-button",
    content:
      "Clicking button provides you with options to enable or suppress email threshold alerts for system events.",
  },
  {
    selector: "#refresh-channel-tokens-button",
    content:
      "Clicking this button will perform a system request to refresh the available channel tokens. The channel tokens can be used to narrow channel message searches in the Find or Reprocess page.",
  },
  {
    selector: "#mc-server-info-button",
    content:
      "Clicking this button will load a work area where you can see all details like MC Version, Java Version, and last activity time for all of your registered MC instances.",
  },
  {
    selector: "#update-environment-button",
    content:
      "Clicking this button will load a page where users can set key server level thresholds to monitor such as system level pruning.",
  },
  {
    selector: "#modify-channels-button",
    content:
      "Clicking this button will load a page where users can set key channel level thresholds for channels on this Mirth Connect environment to monitor.",
  },
  {
    selector: "#channel-search-filter",
    content:
      "Users can make use of full dates by selecting one or more dates from the day picker. If more detailed data is required, users can toggle on the custom date range and add a start and end date.",
  },
  {
    selector: "#channel-data-grid",
    content:
      "This area allows you to see all the summary of the system events that match your criteria from the search criteria filters above. Click reported during the search window. Clicking on the any row content in the Label column on the far left will launch a system event detail page where additional information regarding the system event clicked on can be displayed.",
  },
  {
    selector: "#Channels-column-7",
    content:
      "This column is the number of queued messages at the time of polling. This does not represent the total queue count.",
  },
];

export const environmentDetailsExternalSteps = [
  {
    selector: "#environment-details-header-1",
    content:
      "This area shows the client name and environment name of the Mirth Connect Environment. If you chose to modify the name of the environment, please be aware that this will not change the setting on your remote Mirth Connect server.",
  },
  {
    selector: "#environment-details-header-2",
    content:
      "This area shows the summary of the Mirth Connect Environment.",
  },
  {
    selector: "#channel-action-button",
    content:
      "Clicking button provides you with options to enable or suppress email threshold alerts for system events.",
  },
  {
    selector: "#mc-server-info-button",
    content:
      "Clicking this button will load a work area where you can see all details like MC Version, Java Version, and last activity time for all of your registered MC instances.",
  },
  {
    selector: "#environment-entitlement-button",
    content:
      "Clicking this button will load a page where users can select channels to allocate their entitlements. To simplify mass allocation or revocation entitlements make use of the select all and unselect all buttons. After any changes to the page, be sure to click the Save Changes button to prevent lost work.",
  },
  {
    selector: "#update-environment-button",
    content:
      "Clicking this button will load a page where users can set key server level thresholds to monitor such as system level pruning.",
  },
  {
    selector: "#modify-channels-button",
    content:
      "Clicking this button will load a page where users can set key channel level thresholds for channels on this Mirth Connect environment to monitor.",
  },
  {
    selector: "#channel-search-filter",
    content:
      "Users can make use of full dates by selecting one or more dates from the day picker. If more detailed data is required, users can toggle on the custom date range and add a start and end date.",
  },
  {
    selector: "#channel-data-grid",
    content:
      "This area allows you to see all the summary of the system events that match your criteria from the search criteria filters above. Click reported during the search window. Clicking on the any row content in the Label column on the far left will launch a system event detail page where additional information regarding the system event clicked on can be displayed.",
  },
  {
    selector: "#Channels-column-7",
    content:
      "This column is the number of queued messages at the time of polling. This does not represent the total queue count.",
  },
];

export const channelActionModalSteps = [
  {
    selector: "#channel-action-all-dropdown",
    content:
      "Here is the dropdown selection for the channel action modal.",
  },
  {
    selector: "#select-action-to-take-column",
    content:
      "Select the action to take for each channel.",
  },
];
